import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { getBrowserProduct } from '@/helpers';

@Component({
  name: 'CmgFacPill',
})
export default class CmgFacPill extends Vue {
  @Prop({ required: true, type: String })
  text!: string;

  get safariClass() {
    const product = getBrowserProduct(window.navigator);
    return product === 'Safari' || product === 'MobileSafari' ? 'safari' : 'not-safari';
  }
}
